<template>
  <div>
    <div class="filter">
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="title">Nosaukums</label>
            <select name="title" id="title" v-model="filter_title" class="form-control">
              <option value="">Visi nosaukumi</option>
              <option v-for="title in item_titles" :key="'title'+title.id" :value="title.id">{{title.title}}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for=collection>Kolekcija</label>
            <select name=collection id="collection" v-model="filter_collection" class="form-control">
              <option value="">Visas kolekcijas</option>
              <option v-for="collection in item_collections" :key="'collection'+collection.id" :value="collection.id">{{collection.title}}</option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <button class="btn btn-primary" @click="getItems()"><i class="fas fa-search"></i> Meklēt</button>
            <button class="btn btn-primary" @click="clearFilter()"><i class="fas fa-times"></i> Notīrīt filtru</button>
          </div>
        </div>
        <div class="col-12 text-center p-2">
          <hr>
          <span class="text-muted">
                Kopā atrasti <strong>{{total_count}}</strong> ieraksti
          </span>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="loader" v-if="loading">
        <img src="/images/loading.svg" alt="Loading">
      </div>
      <table class="table table-responsive-xl table-hover">
        <thead class="bg-primary text-white">
        <tr>
          <th>Attēls</th>
          <th>Numurs</th>
          <th>Akts</th>
          <th>Kolekcija</th>
          <th>Nosaukums</th>
          <th>Ieguve</th>
          <th>Apraksts</th>
          <th>Darbības</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>
            <img style="width:150px; height:auto" v-if="item.images.length>0" :src="'/public/image/thumb/'+item.images[0].file_name" alt="" title="">
          </td>
          <td style="width:150px">{{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span></td>
          <td><span v-if="item.act">{{item.act.act_number}}</span></td>
          <td><span v-if="item.collection">{{item.collection.title}}</span></td>
          <td><span v-if="item.title">{{item.title.title}}</span></td>
          <td><span v-if="item.transfer_type">{{item.transfer_type.collection_title}}</span></td>
          <td style="max-width:500px">{{item.description}}</td>
          <td class="actions">
            <a v-if="item.act" class="open" :href="'/act/'+item.act.id" target="_blank" v-tooltip:top="'Uz aktu'"><span class="material-icons">open_in_new</span></a>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="pagination.show_pagination">
        <div class="pages">
          <div class="page" @click="getItems(1)" v-if="pagination.show_first_page">1</div>
          <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
          <div class="page" @click="getItems(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
          <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
          <div class="page" @click="getItems(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
          <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
          <div class="page" @click="getItems(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props:['list_type','item_titles','item_collections'],
  mounted()
  {
    this.getItems();
  },
  data()
  {
    return{
      items:[],
      loading:false,
      pagination:[],
      items_per_page:30,
      filter_title:"",
      filter_collection:"",
      total_count:"",
    }
  },
  methods:{
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    normalDate(date)
    {
      var d = moment(date).format('DD.MM.YYYY.');
      if(moment(d, 'DD.MM.YYYY.').isValid()) {
        return d;
      }
      else {
        return null;
      }
    },
    clearFilter()
    {
      this.filter_title = "";
      this.filter_collection = "";
      this.getItems();
    },
    getItems(page = 1)
    {
      var that = this;
      that.loading = true;
      axios.post('/dashboard/errors/get-items',{
        list_type: that.$props.list_type,
        page:page,
        items_per_page: that.items_per_page,
        filter_title: that.filter_title,
        filter_collection: that.filter_collection,
      }).then(response => {
        that.items = response.data.items;
        that.total_count = response.data.total_count,
        that.loading = false;
        that.pagination = response.data.pagination;
        that.scrollToTop();

      })
    }
  }
}
</script>


<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.filter{
  padding: 20px;
  box-shadow: 0 1px 20px rgb(0 0 0 / 20%);
  margin-bottom: 10px;
}
.open{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  text-decoration: none;
}
.delete{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
  width: 24px;
  height: 24px;
  background-color: #ddd;
  color: #fff;
  transition: all 0.2s ease-in-out;
  border-radius: 100%;
  text-decoration: none;
  &:hover{
    background: $red;
  }
}
.results{
  position:relative;
  .loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    img{
      width:100px;
      height:100px;
    }

  }
}
.pagination{
  margin-top:20px;
  padding-top:20px;
  border-top:solid 2px #777;
  .pages{
    display:flex;
    margin:auto;
    .page{
      width:32px;
      height:32px;
      margin:0 10px;
      display:flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius:100%;
      font-weight: 700;
      transition: all .2s ease-in-out;
      &:hover{
        background:$blue;
        color:#fff;
      }
    }
    .delimiter{
      width:20px;
      height:32px;
      margin:0 0px;
      display:flex;
      color:#333;
      align-items: center;
      justify-content: center;
    }
    .currentPage{
      background:$blue;
      color:#fff;
      cursor:auto;
    }

  }
}
</style>